import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable, of} from "rxjs";
import {environment} from 'src/environments/environment';
import {AppModule} from '../app.module';
import {MsalService} from "@azure/msal-angular";

@Injectable()
export class AuthService {
  nameBS = new BehaviorSubject<string>('');
  nameObs = this.nameBS.asObservable();

  emailBS = new BehaviorSubject<string>('');
  emailObs = this.emailBS.asObservable();

  roleBS = new BehaviorSubject<string>('');
  roleObs = this.roleBS.asObservable();

  test: String = 'test';

  constructor(private http: HttpClient, private msalService: MsalService) {
  }

  headers = new HttpHeaders();

  getMenu() {
    return this.http.get<any>(environment.authApiUrl + 'layout/EUR', {});
  }

  getPages() {
    return this.http.get<any>(environment.authApiUrl + 'pages/EUR', {});
  }

  getUser() {
    return this.http.get<any>(environment.authApiUrl + 'users/EUR', {});
  }

  setFilter(filters: string) {
    return this.http.post<any>(environment.authApiUrl + 'users/filter/EUR', {filters});
  }

	setColumnSettings(columnSettings: string) {
	  return this.http.post<any>(environment.authApiUrl + 'users/column-settings/EUR', columnSettings);
	}

  getAvailableRole() {
    const params: HttpParams = new HttpParams()
    return this.http.get<any>(environment.authApiUrl + 'users/available-roles/EUR', {params});
  }
  setUserRole(
    role: string
  ): Observable<any[]> {
    const httpoptions: Object = {
      params: new HttpParams().set('role', role).set('app', 'EUR')
    };
    return this.http.post<any>(
      environment.authApiUrl + "masterdata/user/active-role",
      role,
      httpoptions
    );

  }

  refresh() {

    of(Object.keys(localStorage)
      .filter(key => !key.includes("appVersion"))
      .map(key => localStorage.removeItem(key))
    ).subscribe(res =>
      this.msalService.logoutRedirect()
    );

  }
}
